<template>
  <heartland-product-badge start-color="#5d5d5d"
                           class="missing-image"
                           text-fill="#e6e6e6"
                           text-stroke="transparent"
                           :font-size="32"
                           :words="alt.split(' ')"
                           stroke-color="#1c1c1c"
                           stop-color="#222" >
    <image v-bind:xlink:href="logo"
           opacity="0.5"
           x="30"
           y="49.5"
           width="180"
           height="166"/>
  </heartland-product-badge>
</template>

<script>
  import HeartlandProductBadge from './heartland-product-badge'
  import BaseMissingImage from '^/base/_base-missing-image'
  import {staticUrl} from "^/utils"

  export default {
    name: "base-missing-image",
    extends: BaseMissingImage,
    components: {
      HeartlandProductBadge,
    },
    computed:{
      logo(){
        return staticUrl('img/client/logo-footer.png')
      }
    }
  }
</script>

<style scoped>
  .missing-image{
    width:100%;
  }
</style>


// WEBPACK FOOTER //
// ixcms/themes/heartlandtan/src/vue-src/base/_base-missing-image.vue